<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-06-26 14:03:01
 * @LastEditors: sunyan 1055697528@qq.com
 * @LastEditTime: 2024-04-07 10:19:02
 * @FilePath: \jsczt\src\views\home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <el-tree
            ref="tree"
            :data="data"
            :props="defaultProps"
            node-key="classinfoid"
            @node-click="handleNodeClick"
            :default-expanded-keys="expandedKeys"
            highlight-current
         >
         <template slot-scope="{ node }">
          <span class="activeNode" v-if="isSelectedNode(node.key) && !node.disabled">
            {{ node.label }}
            <i class="iconfont icon-arrow-r-copy" style="color: #e8cca8;"></i>
          </span>
          <span v-else>
            {{ node.label }}
          </span>
        </template>
      </el-tree>
    </div>
  </template>

<script>
export default {
  name: 'leftTree',
  props: {
    curnode: {
      type: String,
      default: '5'
    }
  },
  data () {
    return {
      data: [],
      selectedNodeId: null,
      selectedKey: '',
      expandedKeys: [],
      defaultProps: {
        children: 'chlid',
        label: 'cname',
        disabled: 'hasChild'
      }
    }
  },
  watch: {
    $route: {
      handler (val) {
        // 监听当前路径
        if (val.params.classinfoid) {
          this.expandedKeys.push(parseInt(val.params.classinfoid))
          this.selectedKey = val.params.classinfoid
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(val.params.classinfoid)
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  async created () {
    await this.getTree()
    this.isSelectedNode(this.curnode)
  },
  async mounted () {
    this.expandedKeys.push(parseInt(this.curnode))
    this.selectedKey = this.curnode
    // if (this.curnode) {
    //   this.$nextTick(() => {
    //     this.$refs.tree.setCurrentKey(this.curnode)
    //     this.isSelectedNode(this.curnode)
    //   })
    // }
  },
  methods: {
    async getTree () {
      await this.$http.get('/api/classinfo/getTree', {
        params: {
          topId: '2'
        }
      }).then(res => {
        if (this.$route.name === 'overView') {
          this.data.push(res.data.data.chlid[0])
        }
        if (this.$route.name === 'overView2') {
          this.data = []
          this.data.push(res.data.data.chlid[1])
        }
        if (this.$route.name === 'overViews' || this.$route.name === 'overViewt') {
          this.data = []
          this.data.push(res.data.data.chlid[2])
        }
      })
    },
    isSelectedNode (node) {
      return node.toString() === this.selectedKey
    },
    handleNodeClick (data, node, instance) {
      
      this.selectedKey = data.classinfoid.toString()
      this.$emit('curdata', data)
      if (data.child && data.child.length > 0) {
      // 如果节点有子节点，则取消选中父节点
        instance.setCurrentKey(' ')
      }
    }
  }
}
</script>
<style>
.activeNode{
  font-weight: bold;
  color: #245d94;
  /* border: 1PX solid #838484; */
}
/* 组件级样式 */
.el-tree{
  width: 300PX;
  background: #f7fafd !important;
  border-left: 5PX solid #caa06d !important;
  border-right: 1PX solid #c9d1da !important;
  font-size: 18PX !important;
  min-width: 150PX;
  font-weight: 400;
  line-height: 60PX;
  color: #838484;
  padding: 15PX 10PX 15PX 25PX !important;/* 一层节点 */
}

.el-tree-node__content>.el-tree-node__expand-icon{
    display: none !important;
}
.el-tree-node__label{
    font-size: 18PX !important;
}
.el-tree-node__content{
    height: 50PX  !important;
    font-size: 18PX  !important;
    font-weight: 400  !important;
    line-height: 60PX  !important;
}
.el-tree-node .is-current.el-tree-node__content {
  /* background: none !important; */
}
.el-tree-node:focus .el-tree-node__content {
  /* background: none !important; */
}
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
  color: #245d94 !important;
}

.el-tree--highlight-current .el-tree-node.is-current .el-tree-node__content {
  /* background: none !important; */
}
</style>



// WEBPACK FOOTER //
// src/components/leftTree.vue